import React, { useState, useEffect } from 'react';
import { useMobile } from '../hooks/useMobile';

const DigitalClock = () => {
  const { isMobile } = useMobile();
  const [time, setTime] = useState(new Date());
  const [blink, setBlink] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
      setBlink(prev => !prev);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const containerStyle = {
    display: 'block', // Gewoon een block, geen gekke offsets
  };

  const dateStyle = {
    color: '#FFF',
    fontFamily: '"DM Sans", sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '16px',
    textAlign: 'left',
    marginLeft: '24px', // Marge voor de datum
    marginBottom: '0px', // Ruimte tussen datum en klok
    letterSpacing: '-0.02em',
  };

  const clockStyle = {
    fontFamily: '"DM Sans", sans-serif',
    fontSize: isMobile ? '36px' : '64px',
    fontWeight: 500,
    color: 'white',
    display: 'flex',
    justifyContent: 'flex-start',
    width: isMobile ? '190px' : '340px',
    letterSpacing: '-0.05em',
    marginLeft: '16px',
  };

  const timePartStyle = {
    display: 'inline-block',
    minWidth: isMobile ? '22px' : '40px',
    textAlign: 'center',
  };

  const colonStyle = {
    opacity: blink ? 0.3 : 0.6,
    transition: 'opacity 0.3s ease-in-out',
    display: 'inline-block',
    width: isMobile ? '11px' : '20px',
    textAlign: 'center',
  };

  const formatTime = (date) => {
    const dayNames = [
      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
    ];
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ];

    const dayName = dayNames[date.getDay()];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const suffix = getDaySuffix(day);
    const dateString = `${dayName}, ${month} ${day}${suffix}`;

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return {
      date: dateString,
      time: (
        <div style={{ display: 'flex', width: '100%' }}>
          <span style={timePartStyle}>{hours}</span>
          <span style={colonStyle}>:</span>
          <span style={timePartStyle}>{minutes}</span>
          <span style={colonStyle}>:</span>
          <span style={timePartStyle}>{seconds}</span>
        </div>
      ),
    };
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const formatted = formatTime(time);

  return (
    <div style={containerStyle}>
      <div style={dateStyle}>
        {formatted.date}
      </div>
      <div style={clockStyle}>
        {formatted.time}
      </div>
    </div>
  );
};

export default DigitalClock;